"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _reactBicycle = require("react-bicycle");
var _react = _interopRequireWildcard(require("react"));
var _loginConnector = _interopRequireDefault(require("../../../../../login/login-connector"));
var _rowConfig = _interopRequireDefault(require("../../../../core/row-config"));
var _formGroup = _interopRequireDefault(require("../../../../core/form-group"));
var _label = _interopRequireDefault(require("../../../../core/label"));
var _editableField = _interopRequireDefault(require("../../../../core/editable-field"));
var _row = _interopRequireDefault(require("../../../../core/row"));
var _col = _interopRequireDefault(require("../../../../core/col"));
var _helpButton = _interopRequireDefault(require("../../../../core/help-button"));
var _competitionDays = _interopRequireDefault(require("./competition-days"));
var _entryTypeOverrides = _interopRequireDefault(require("./entry-type-overrides"));
var _datesAndLimitsHelp = _interopRequireDefault(require("./dates-and-limits-help"));
var _changeCompetitionDates = _interopRequireDefault(require("./change-competition-dates"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _mergeBqlQueries(firstQuery, secondQuery) { if (secondQuery === null) { return firstQuery; } const result = {}; let firstQueryUpdated = false; let secondQueryUpdated = false; for (let key in firstQuery) { if (key in firstQuery) { if (!secondQuery[key]) { firstQueryUpdated = true; result[key] = firstQuery[key]; } else if (firstQuery[key] !== secondQuery[key]) { result[key] = _mergeBqlQueries(firstQuery[key], secondQuery[key]); if (result[key] !== secondQuery[key]) { firstQueryUpdated = true; secondQueryUpdated = true; } } else { result[key] = firstQuery[key]; } } } if (!firstQueryUpdated) { return secondQuery; } for (let key in secondQuery) { if (key in secondQuery && !result[key]) { secondQueryUpdated = true; result[key] = secondQuery[key]; } } return secondQueryUpdated ? result : firstQuery; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var _ref = /*#__PURE__*/_react.default.createElement(_helpButton.default, null, /*#__PURE__*/_react.default.createElement(_datesAndLimitsHelp.default, null));
var _ref2 = /*#__PURE__*/_react.default.createElement("h4", {
  className: "card-header"
}, "Key Competition Dates");
var _ref3 = /*#__PURE__*/_react.default.createElement(_label.default, null, "Open for Entry");
var _ref4 = /*#__PURE__*/_react.default.createElement(_label.default, null, "Entries Close as Of");
var _ref5 = /*#__PURE__*/_react.default.createElement(_label.default, null, "Late Fees Become Due");
const SetUpCompetition = (0, _loginConnector.default)(class extends _react.Component {
  constructor(...args) {
    super(...args);
    _defineProperty(this, "_onUpdateCompetition", (fieldname, value) => {
      this.props.onUpdateCompetition(this.props.competition.id, fieldname, value);
    });
    // TODO This is a bit quick and dirty and needs parameterising
    _defineProperty(this, "_validateOpenDate", value => {
      if (value >= this.props.competition.yearID + '-01-20' || this.props.userIsSystemAdmin) return;
      return 'Open for entry date must be on or after 20 January';
    });
    _defineProperty(this, "_onUpdateOpenDate", value => {
      if (this._validateOpenDate(value)) return;
      this.props.onUpdateCompetition(this.props.competition.id, 'openForOnlineEntryDate', value);
    });
  }
  render() {
    const comp = this.props.competition;
    if (!comp.isAdministratedByUser) return null;
    return /*#__PURE__*/_react.default.createElement("div", null, _ref, /*#__PURE__*/_react.default.createElement(_changeCompetitionDates.default, {
      competition: this.props.competition,
      userIsSystemAdmin: this.props.userIsSystemAdmin
    }), /*#__PURE__*/_react.default.createElement(_row.default, null, /*#__PURE__*/_react.default.createElement(_col.default, {
      lg: 5
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "card"
    }, _ref2, /*#__PURE__*/_react.default.createElement("div", {
      className: "card-block"
    }, /*#__PURE__*/_react.default.createElement(_row.default, null, /*#__PURE__*/_react.default.createElement(_rowConfig.default, {
      columns: [{
        sm: 5,
        md: 6
      }, {
        sm: 7,
        md: 6
      }]
    }, /*#__PURE__*/_react.default.createElement(_formGroup.default, null, _ref3, /*#__PURE__*/_react.default.createElement(_col.default, null, /*#__PURE__*/_react.default.createElement(_editableField.default, {
      enabled: true,
      type: "Date",
      name: "openForOnlineEntryDate",
      value: comp.openForOnlineEntryDate,
      onChange: this._onUpdateOpenDate,
      required: true,
      customValidation: this._validateOpenDate
    }))), /*#__PURE__*/_react.default.createElement(_formGroup.default, null, _ref4, /*#__PURE__*/_react.default.createElement(_col.default, null, /*#__PURE__*/_react.default.createElement(_editableField.default, {
      enabled: true,
      type: "Date",
      name: "closedForOnlineEntryDate",
      value: comp.closedForOnlineEntryDate,
      onChange: this._onUpdateCompetition.bind(this, 'closedForOnlineEntryDate'),
      required: true
    }))), /*#__PURE__*/_react.default.createElement(_formGroup.default, null, _ref5, /*#__PURE__*/_react.default.createElement(_col.default, null, /*#__PURE__*/_react.default.createElement(_editableField.default, {
      enabled: true,
      type: "Date",
      name: "lateFeesDueDate",
      value: comp.lateFeesDueDate,
      onChange: this._onUpdateCompetition.bind(this, 'lateFeesDueDate'),
      required: true
    })))))))), /*#__PURE__*/_react.default.createElement(_col.default, {
      lg: 7
    }, /*#__PURE__*/_react.default.createElement(_competitionDays.default, {
      competitionID: comp.id,
      competitionDays: comp.competitionDays,
      userCanModifyCompetitionStructure: comp.userCanModifyCompetitionStructure
    }))), /*#__PURE__*/_react.default.createElement(_entryTypeOverrides.default, {
      entryTypeOverrides: comp.entryTypeOverrides,
      userIsSystemAdmin: this.props.userIsSystemAdmin
    }));
  }
});

// *******************************************************************************
// Data and actions
// *******************************************************************************
var _ref6 = _mergeBqlQueries({
  id: true,
  userCanModifyCompetitionStructure: true,
  yearID: true,
  openForOnlineEntryDate: true,
  closedForOnlineEntryDate: true,
  lateFeesDueDate: true,
  isPublished: true,
  isAdministratedByUser: true,
  competitionDays: _mergeBqlQueries({}, _competitionDays.default.partials.CompetitionDays),
  entryTypeOverrides: _mergeBqlQueries({}, _entryTypeOverrides.default.partials.EntryTypeOverrides)
}, _changeCompetitionDates.default.partials.Competition);
var _default = exports.default = (0, _reactBicycle.connect)(SetUpCompetition, props => ({
  userIsSystemAdmin: true,
  ["competition(competitionSlug:" + JSON.stringify(props.match.params.competitionSlug) + ",yearID:" + JSON.stringify(+props.match.params.yearID) + ")"]: _ref6
}), (client, props) => ({
  onUpdateCompetition(id, field, value) {
    return client.update('Competition.set', {
      id,
      field,
      value
    });
  }
}));